import CustomLogo from './CustomLogo';

export default CustomLogo;
